import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { HttpClient } from '@angular/common/http';
import { SubscriptionItem } from '../../models/subscription-item';
import { Customer } from '../../models/customer';
import { ENV } from '../../environments/environment';

@Injectable()
export class SubscriptionsService {
  public SubscriptionItem: SubscriptionItem;

  getItem(itemId: number): Observable<SubscriptionItem> {
    return this.http.get<any>(`${ENV.apiUrl}/v${ENV.apiVersion}/integrations/clover/items/${itemId}`)
      .map(response => response.data);
  }

  getItems(): Observable<SubscriptionItem[]> {
    return this.http.get<any>(`${ENV.apiUrl}/v${ENV.apiVersion}/integrations/clover/items`)
      .map(response => response.data);
  }

  getInvoices(contactId: string): Observable<any> {
    return this.http.get<any>(`${ENV.apiUrl}/v${ENV.apiVersion}/subscriptions/invoices?contact_id=${contactId}`)
      .map(response => response.data);
  }

  getEvents(contactId: string): Observable<any> {
    return this.http.get<any>(`${ENV.apiUrl}/v${ENV.apiVersion}/subscriptions/events?contact_id=${contactId}`)
      .map(response => response.data);
  }

  regenerate(contactId: string, hash: string): Observable<any> {
    return this.http.post<any>(`${ENV.apiUrl}/v${ENV.apiVersion}/subscriptions/regenerate`,{qr_code: hash, contact_id: contactId})
      .map(response => response.data);
  }

  pricing(): Observable<any> {
    return this.http.get<any>(`${ENV.apiUrl}/v${ENV.apiVersion}/subscriptions/pricing`)
      .map(response => response.data);
  }

  createSubscription(requestPayload): Observable<Customer> {
    return this.http.post<any>(`${ENV.apiUrl}/v${ENV.apiVersion}/subscriptions`,requestPayload)
      .map(response => response.data);
  }

  ckSubscription(codeType: string, qrCodeHash: string): Observable<any> {
    return this.http.get<any>(`${ENV.apiUrl}/v${ENV.apiVersion}/subscriptions/check-active/${codeType}/${encodeURIComponent(qrCodeHash)}`)
      .map(response => response.data);
  }

  runIntake(subscriptionId: string): Observable<any> {
    return this.http.post<any>(`${ENV.apiUrl}/v${ENV.apiVersion}/subscriptions/process-intake`,{subscription_id:subscriptionId})
      .map(response => response.data);
  }

  constructor(public http: HttpClient) {}
}



// WEBPACK FOOTER //
// ./src/services/subscriptions/subscriptions-service.ts